import { Checkbox } from "components/Atoms/inputs/Checkbox";
import CurrencyInput from "components/CurrencyInput";
import LabelledDivRow from "components/LabelledDivRow";
import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";
import UrlInput from "components/urlinput";
import moment from "moment";
import React from "react";

interface Props {
  onSaleDate: moment.Moment
  onSaleDateChange: (date: moment.Moment) => void

  soldOut: boolean
  onSoldOutChange: (soldOut: boolean) => void

  doorPrice: number
  onDoorPriceChange: (price: number) => void

  presalePrice: number
  onPresalePriceChange: (price: number) => void

  reducedPrice: number
  onReducedPriceChange: (price: number) => void

  ticketLink: string
  onTicketLinkChange: (link: string) => void

  ticketCurrency: server.dto.Currencies
}

const TicketsPanel = (props: Props) => {
  return <>
    <LabelledDivRow label={RESX.Ticket.TicketLink}>
      <UrlInput
        value={props.ticketLink}
        onValueChange={props.onTicketLinkChange}
        validatorKey="ticketLink"
        maxLength={serverReference.constants.url.maxUrlLength}
      />
    </LabelledDivRow>

    <LabelledDivRow label={RESX.TicketTypes.Door}>
      <CurrencyInput
        currency={props.ticketCurrency}
        value={props.doorPrice}
        onChange={props.onDoorPriceChange}
        canBeEmpty={true}
        canBeNegative={false}
      />
    </LabelledDivRow>
    <LabelledDivRow label={RESX.TicketTypes.Presale}>
      <CurrencyInput
        currency={props.ticketCurrency}
        value={props.presalePrice}
        onChange={props.onPresalePriceChange}
        canBeEmpty={true}
        canBeNegative={false}
      />
    </LabelledDivRow>

    <LabelledDivRow label={RESX.TicketTypes.Reduced}>
      <CurrencyInput
        currency={props.ticketCurrency}
        value={props.reducedPrice}
        onChange={props.onReducedPriceChange}
        canBeEmpty={true}
        canBeNegative={false}
      />
    </LabelledDivRow>
    <LabelledDivRow label={RESX.Ticket.OnPresale}>
      {/* Legacy form: cancels the checkbox padding and keeps the row height when unchecked */}
      <div style={{ minHeight: 32, marginLeft: -8 }}>
        <OptionalDatePicker
          validatorKey="onPresaleDate"
          minDate={moment(serverReference.constants.appointment.minDate)}
          maxDate={moment(serverReference.constants.appointment.maxDate)}
          value={props.onSaleDate}
          onChange={props.onSaleDateChange}
        />
      </div>
    </LabelledDivRow>
    <LabelledDivRow label={RESX.Ticket.SoldOut}>
      <Checkbox
        checked={props.soldOut}
        onChange={(_, checked) => { props.onSoldOutChange(checked); }}
      />
    </LabelledDivRow>
  </>;
};

export default TicketsPanel;